/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Connectors_Field_Registry_Url_HintInputs */



/**
* | output |
* | --- |
* | "The npm registry this package is fetched from. Empty uses the built-in registry — but only in oneAI's cloud: relays never use it, so a package that runs on a..." |
*
* @param {Partner_Connectors_Field_Registry_Url_HintInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_connectors_field_registry_url_hint = /** @type {((inputs?: Partner_Connectors_Field_Registry_Url_HintInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Connectors_Field_Registry_Url_HintInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Die npm-Registry, aus der dieses Paket geladen wird. Leer bedeutet die eingebaute Registry – aber nur in der oneAI-Cloud: Relays verwenden sie nie, ein Paket, das auf einem Relay läuft, braucht hier also seine Registry (z. B. oneai-pkgs).")
	return /** @type {LocalizedString} */ ("The npm registry this package is fetched from. Empty uses the built-in registry — but only in oneAI's cloud: relays never use it, so a package that runs on a relay needs its registry set here (e.g. oneai-pkgs).")
});